import React from 'react'
// import classNames from 'classnames'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import FontAwesome from 'react-fontawesome'
import { IconButton } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import DialogBox from '../../utils/employer/dialogComponent.utils'
import moment from 'moment'
import { formatNumber, formatTime } from '../../utils/openForWork.utils'
import { TimeReportFormComponent } from './workshiftNormalUser.component'
import ModalComponent from '../layout/modal.component'

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top'
  },
  tablecell2: {
    fontSize: '12px',
    verticalAlign: 'top',
    padding: theme.spacing(1.5),
    borderBottom: '1px solid lightgrey'
  }
})

const JournalRow = ({
  classes,
  // added_to_invoice,
  getJournalEdit,
  warnDeleteJournal,
  closeWarnDeleteJournal,
  warnDelateJournal,
  deleteJournal,
  invoice_id,
  journal_id,
  task_description,
  totalJournalAmount,
  dateTimeRows,
  delete_journal_id,
  isEditJournal,
  cancelJournalEdit,
  updateJournalSnackbar,
  updateJournalFailSnackbar
}) => {
  const [expandIcon, setExpandIcon] = React.useState(false)
  const handleExpandClick = () => setExpandIcon((prevExpand) => !prevExpand)
  const renderExpandableRows = (t) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#E0EFF3',
        border: '1px solid lightgrey',
        borderRadius: '10px',
        margin: '0px 200px'
      }}
    >
      <table>
        <thead>
          <tr>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell1')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell2')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell3')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell4')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell5')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {t('workshift.cell6')}
            </th>
            <th component="th" scope="row" className={classes.tablecell2}>
              {' '}
              {t('workshift.cell7')}
            </th>
          </tr>
        </thead>
        <tbody>
          {dateTimeRows.map((el, index) => (
            <tr key={index}>
              <td component="th" scope="row" className={classes.tablecell2}>
                {moment(el.date).format('DD.MM.YYYY')}
              </td>
              <td component="th" scope="row" className={classes.tablecell2}>
                {formatTime(el.startTime)}
              </td>
              <td component="th" scope="row" className={classes.tablecell2}>
                {' '}
                {formatTime(el.endTime)}
              </td>
              <td component="th" scope="row" className={classes.tablecell2}>
                {formatNumber(el.totalHour)}
              </td>
              <td component="th" scope="row" className={classes.tablecell2}>
                {new Intl.NumberFormat('fi-FI', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(el.amount)}
              </td>
              <td
                component="th"
                scope="row"
                className={classes.tablecell2}
                style={{ maxWidth: '200px', wordWrap: 'break-word' }}
              >
                {el.additionalInfo}
              </td>
              <td component="th" scope="row" className={classes.tablecell2}>
                {new Intl.NumberFormat('fi-FI', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(el.totalAmount)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
  const totalJournalHours = dateTimeRows.reduce(
    (sum, item) => sum + item.totalHour,
    0
  )
  // State variables for modal control
  const [open, setOpen] = React.useState(false)
  const [selectedContent, setSelectedContent] = React.useState(null)
  const [selectedMaxWidth, setSelectedMaxWidth] = React.useState('md')

  // Function to open modal with specific content and width
  const handleOpenForm = (component, width = 'md') => {
    getJournalEdit(journal_id)
    setSelectedContent(component)
    setSelectedMaxWidth(width)
    setOpen(true)
  }
  const handleClose = (event) => {
    if (event) {
      event.stopPropagation()
    }
    setOpen(false)
    setSelectedContent(null)
    setSelectedMaxWidth('md')
    cancelJournalEdit()
  }

  React.useEffect(() => {
    if (updateJournalSnackbar || updateJournalFailSnackbar) {
      setOpen(false)
    }
  }, [updateJournalSnackbar, updateJournalFailSnackbar])
  return (
    <Translation>
      {(t) => {
        return (
          <>
            <TableRow style={{ cursor: 'pointer' }} onClick={handleExpandClick}>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {invoice_id}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {journal_id}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
                style={{ maxWidth: '200px', wordWrap: 'break-word' }}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: task_description
                  }}
                ></div>
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {formatNumber(totalJournalHours)}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {totalJournalAmount}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                <div style={{ display: 'flex' }}>
                  {!invoice_id ? (
                    <div style={{ display: 'flex' }}>
                      <p
                        className="link"
                        style={{ marginRight: '10px' }}
                        onClick={() => {
                          handleOpenForm(
                            <TimeReportFormComponent
                              isEditJournal={isEditJournal}
                              t={t}
                            />,
                            '1440px'
                          )
                        }}
                      >
                        <FontAwesome name="pencil" />
                      </p>
                      <p
                        style={{
                          marginLeft: '10px',
                          marginRight: '15px'
                        }}
                        onClick={() => {
                          warnDeleteJournal(journal_id)
                        }}
                      >
                        <FontAwesome
                          name="window-close"
                          style={{
                            color: '#F67131'
                          }}
                        />
                      </p>
                    </div>
                  ) : (
                    <div style={{ display: 'flex' }}>
                      <p
                        className="link"
                        style={{ marginRight: '10px', color: 'grey' }}
                      >
                        <FontAwesome name="pencil" />
                      </p>
                      <p
                        style={{
                          marginLeft: '10px',
                          marginRight: '15px'
                        }}
                      >
                        <FontAwesome
                          name="window-close"
                          style={{
                            color: 'grey'
                          }}
                        />
                      </p>
                    </div>
                  )}
                  <IconButton aria-label="expand row" size="small">
                    {expandIcon ? (
                      <KeyboardArrowUpIcon fontSize="large" />
                    ) : (
                      <KeyboardArrowDownIcon fontSize="large" />
                    )}
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
            {expandIcon ? (
              <TableRow>
                <TableCell colSpan={6}>{renderExpandableRows(t)}</TableCell>
              </TableRow>
            ) : null}
            <DialogBox
              classes={classes}
              isOpen={warnDelateJournal}
              onClose={() => {
                closeWarnDeleteJournal()
              }}
              title={t('ws_journal.del')}
              content={t('ws_journal.delContent')}
              buttons={deleteButton(t, deleteJournal, delete_journal_id)}
              showCloseButton={true}
            />
            <ModalComponent
              open={open}
              onClose={handleClose}
              content={selectedContent}
              maxWidth={selectedMaxWidth}
            />
          </>
        )
      }}
    </Translation>
  )
}

const deleteButton = (t, deleteJournal, id) => {
  return [
    {
      text: t('ws_journal.btn1'),
      onClick: () => deleteJournal(id),
      variant: 'contained'
    }
  ]
}

export default withStyles(styles)(JournalRow)
